import * as i from "../../contracts"
import { emptySelection } from "../../constants"

/**
 * Map selections according to given ordering
 * @param order
 * @param selections
 */
export const mapSelections = (selections: i.Selection[] | [], order: string[]): i.Selection[] => order.map(
        type => selections.length && selections.find(
            s => s.outcomeType === type
        ) || emptySelection
    )